import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookies-accepted')) setVisible(true);
  }, []);

  const accept = () => { localStorage.setItem('cookies-accepted', '1'); setVisible(false); };
  const decline = () => { localStorage.setItem('cookies-accepted', '0'); setVisible(false); };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 10000,
      background: '#0d1f3c', borderTop: '2px solid #c4a35a',
      padding: '1.25rem 2rem', display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem',
      boxShadow: '0 -4px 24px rgba(13,31,60,0.25)',
    }}>
      <p style={{ margin: 0, color: 'rgba(250,250,248,0.85)', fontSize: '0.875rem', maxWidth: 620, lineHeight: 1.6 }}>
        Ce site utilise Google Analytics pour mesurer l'audience. Aucune donnée personnelle n'est vendue.{' '}
        <a href="/mentions-legales" style={{ color: '#c4a35a' }}>En savoir plus</a>
      </p>
      <div style={{ display: 'flex', gap: '0.75rem', flexShrink: 0 }}>
        <button onClick={decline} style={{
          padding: '0.5rem 1.25rem', borderRadius: '4px', border: '1px solid rgba(250,250,248,0.3)',
          background: 'transparent', color: 'rgba(250,250,248,0.65)', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600,
        }}>Refuser</button>
        <button onClick={accept} style={{
          padding: '0.5rem 1.25rem', borderRadius: '4px', border: 'none',
          background: '#c4a35a', color: '#0d1f3c', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 700,
        }}>Accepter</button>
      </div>
    </div>
  );
}
